export default __webpack_public_path__ + "bb731c54b977ced4ed470132f86289d4.svg";